// extracted by mini-css-extract-plugin
export default {"titulo":"planTrabajoPage_titulo__Zi8Jp"};